import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { filter, Subject, takeUntil } from 'rxjs';
import { CoachNavItems } from './nav.config';
import { CoachChatUnreadService } from '../../../core/services/coach-chat-unread.service';

@Component({
  selector: 'coach-layout',
  templateUrl: './coach-layout.component.html',
  styleUrl: './coach-layout.component.scss',
})
export class CoachLayoutComponent implements OnInit, OnDestroy {
  @ViewChild('menuContent') menuContent!: TemplateRef<any>;

  activeUrl = '';
  activeTitleKey = '';

  destroyed$ = new Subject();

  constructor(
    private router: Router,
    private offcanvasService: NgbOffcanvas,
    private chatUnread: CoachChatUnreadService,
  ) {
  }

  ngOnInit(): void {
    this.setActiveRoute(this.router.url);
    // The layout only exists for a signed-in coach, so it owns the chat connection's lifetime.
    this.chatUnread.start();

    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd), takeUntil(this.destroyed$))
      .subscribe(event => {
        this.setActiveRoute((event as NavigationEnd).urlAfterRedirects);
        this.offcanvasService.dismiss();
      });
  }

  openMenu() {
    this.offcanvasService.open(this.menuContent, {position: 'start', panelClass: 'coach-menu-offcanvas'});
  }

  closeMenu() {
    this.offcanvasService.dismiss();
  }

  private setActiveRoute(url: string) {
    this.activeUrl = url.split('?')[0];

    const item = CoachNavItems.find(i => (i.exact ? (this.activeUrl === i.url) : this.activeUrl.startsWith(i.url)));
    this.activeTitleKey = item?.titleKey ?? '';
  }

  ngOnDestroy(): void {
    this.chatUnread.stop();
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
